/* DiscoveryAction.js */

"use strict";

class DiscoveryAction {
    constructor(logger, gameEditor, DeviceEntity, userSession, userFeedback) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._targetDevice = {
            method: "single",
            id: this._gameEditor.getDevice()._id
        };
        this._DeviceEntity = DeviceEntity;
        this._userSession = userSession;
        this._modalUserFeedback = userFeedback;
        this.run = this.run.bind(this);
    }

    run() {
        return this._DeviceEntity
            .runDiscoveryWork(this._userSession.activeOrganization.id, this._targetDevice, {}, { launchAndForget: true })
            .catch((err) => {
                this._logger.warn({ error: err }, "SetDefaultConfigAction.run() - Error");
                return this._modalUserFeedback.displayError(err);
            });
    }
}

module.exports = DiscoveryAction;

DiscoveryAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "$teve.entities.Device", "$teve.userSession", "$teve.ui.userFeedback"];

DiscoveryAction.$displayDetails = {
    type: "Action",
    name: "DiscoveryAction",
    icon: "devicemanager.discovery",
    title: "Discover device",
    shown: true,
    order: 2
};
